import React from "react";

import { IgCardSelect } from "@intelligems/ig-theme";
import { ChannelType, DeviceType, VisitorType } from "@intelligems/ig-types";
import { deviceTypeList } from "@src/components/AudienceFilters/utils";

interface DeviceTypeFilterProps {
  onStringFilterChange: (
    newValue: DeviceType | VisitorType | ChannelType,
    filterKey: "deviceType" | "channelType" | "visitorType"
  ) => void;
  deviceType?: DeviceType | null;
}

export const DeviceTypeFilter = ({
  deviceType,
  onStringFilterChange,
}: DeviceTypeFilterProps) => {
  return (
    <IgCardSelect
      options={deviceTypeList.map(({ key, label }) => ({
        title: label,
        description:
          key === "any"
            ? "Include desktop and mobile visitors"
            : `Include only ${label.toLowerCase()} visitors`,
        value: key,
      }))}
      value={deviceType || "any"}
      onChange={(value) => {
        onStringFilterChange(value, "deviceType");
      }}
    />
  );
};
